module.exports = __webpack_public_path__ + "img/kevin.4d9da644.jpg";